import React, { useCallback } from "react";
import { CircularProgress, Typography, Alert } from "@ann/web-components";
import { 
  SuggestionsContainer, 
  SuggestionsListContainer, 
  ContentArea, 
  LoadingContainer, 
  EmptyState 
} from "./Suggestions.styled";
import { Filters } from "../../../Suggestions/components";
import SuggestionItem from "../../../Suggestions/components/SuggestionItem";
import { useFactDetailSuggestions } from "../../hooks";
import { useFactDetailContext } from "../../context";

const Suggestions = ({ factId, onAddSuggestion: externalOnAddSuggestion }) => {
  const {
    loading,
    suggestions,
    filters,
    filterHandlers,
    filterUI,
    handleApprove,
    handleDecline,
    alert,
    handleCloseAlert,
  } = useFactDetailSuggestions(factId);

  const { factData } = useFactDetailContext();

  // Handler que pasa el factId y título al modal externo con lockFact = true
  const handleAddSuggestion = useCallback(() => {
    if (externalOnAddSuggestion) {
      externalOnAddSuggestion({ 
        fact_uuid: factId, 
        title: factData?.factName || null,
      }, true); // lockFact = true para que no pueda cambiar el fact
    }
  }, [externalOnAddSuggestion, factId, factData?.factName]);

  return (
    <SuggestionsContainer>
      {alert && (
        <Alert
          title={alert.title}
          description={alert.description}
          severity={alert.severity}
          maxWidth="500px"
          closable={true}
          autoClose={true}
          autoCloseDelay={5000}
          onClose={handleCloseAlert}
        />
      )}
      <Filters
        loading={loading}
        filters={filters}
        filterHandlers={filterHandlers}
        filterUI={filterUI}
        onAddSuggestion={handleAddSuggestion}
      />
      <ContentArea>
        {loading ? (
          <LoadingContainer>
            <CircularProgress size="xl" />
          </LoadingContainer>
        ) : suggestions.length === 0 ? (
          <EmptyState>
            <Typography category="body" size="medium" weight="regular">
              No suggestions available
            </Typography>
          </EmptyState>
        ) : (
          <SuggestionsListContainer>
            {suggestions.map((suggestion) => (
              <SuggestionItem
                key={suggestion.suggestion_uuid}
                suggestion={suggestion}
                groupId={null}
                isStandalone={true}
                onApprove={handleApprove}
                onDecline={handleDecline}
              />
            ))}
          </SuggestionsListContainer>
        )}
      </ContentArea>
    </SuggestionsContainer>
  );
};

export default Suggestions;
